<div>(Select all that apply)</div>
<div class="_12-px-spacer"></div>
<div *ngIf="amenities" class="button-wrapper-grid">
  <ng-container *ngFor="let amenity of amenityEnum; let i = index">
    <div
      *ngIf="
        !boondock ||
        (amenity.key !== 'laundry' && amenity.key !== 'pool' && amenity.key !== 'tents' && amenity.key !== 'vehicles')
      "
      class="cnt-extended-button"
    >
      <label class="cnt-button" [ngClass]="{ active: selected(amenity.key) }">
        <input type="checkbox" [value]="amenity.key" (change)="toggle(amenity.key)" />
        <div class="cnt-button-icon">
          <curbnturf-site-svgs [type]="amenity.key" [white]="selected(amenity.key)"> </curbnturf-site-svgs>
        </div>
        <div class="cnt-button-copy">{{ amenity.value }}</div>
      </label>
      <div *ngIf="amenity.key === 'electricity' && options(amenity.key)">
        <ion-radio-group aria-label="Electricity Type Selection" [formControl]="electricityOption">
          <ion-item lines="none">
            <ion-radio aria-label="50 Amp" slot="start" mode="md" id="electricity-options-50" value="50" name="electricity"> </ion-radio>
            <ion-label>50 Amp</ion-label>
          </ion-item>
          <ion-item lines="none">
            <ion-radio aria-label="30 Amp" slot="start" mode="md" id="electricity-options-30" value="30" name="electricity"> </ion-radio>
            <ion-label>30 Amp</ion-label>
          </ion-item>
          <ion-item lines="none">
            <ion-radio aria-label="15A / 110V US Household" slot="start" mode="md" id="electricity-options-15" value="15" name="electricity"> </ion-radio>
            <ion-label>15A / 110V US Household</ion-label>
          </ion-item>
        </ion-radio-group>
        <p *ngIf="electricityError" class="alert-danger">
          <i class="icon-cnt-times-circle"></i>
          {{ electricityError }}
        </p>
      </div>
      <div *ngIf="amenity.key === 'cell' && options(amenity.key)">
        <div *ngFor="let signal of signals.controls">
          <div class="">
            <label>
              Who's your cell phone provider?
              <ng-select
                class="dropdown w-dropdown dropdown-toggle"
                [formControl]="signal.controls.source"
                [clearable]="false"
                placeholder="Select"
              >
                <ng-option value="AT&T">AT&T</ng-option>
                <ng-option value="Sprint">Sprint</ng-option>
                <ng-option value="T-Mobile">T-Mobile</ng-option>
                <ng-option value="Verizon">Verizon</ng-option>
                <ng-option value="Other">Other</ng-option>
              </ng-select>
            </label>
          </div>
          <div class="">
            <label>
              How is your coverage on the site?
              <ng-select
                class="dropdown w-dropdown dropdown-toggle"
                [formControl]="signal.controls.strength"
                [clearable]="false"
                placeholder="Select"
              >
                <ng-option [value]="0">There is no coverage</ng-option>
                <ng-option [value]="1">Poor</ng-option>
                <ng-option [value]="2">Fair</ng-option>
                <ng-option [value]="3">Good</ng-option>
                <ng-option [value]="4">Excellent</ng-option>
              </ng-select>
            </label>
          </div>
        </div>
      </div>
      <div *ngIf="amenity.key === 'tents' && selected('tents')" class="description-outer _6px">
        <div class="icon-w-label">
          <div class="per-night">How many?</div>
          <input
            type="number"
            data-test="amenity-tents-count"
            class="text-field-rounded w-input"
            min="0"
            [formControl]="extraTent.controls.count"
            [containerElement]="extraTentCount"
          />
        </div>
        <div
          #extraTentCount="curbnturfDisplayValidationErrorsContainerRef"
          curbnturfDisplayValidationErrorsContainer
        ></div>
        <div class="icon-w-label element-container">
          <div class="element-inner currency-rounded-left">
            <div class="element-bold">$</div>
          </div>
          <input
            type="number"
            data-test="amenity-tents-price"
            class="text-field-rounded-right w-input"
            [formControl]="extraTent.controls.price"
            [containerElement]="extraTentPrice"
          />
          <div class="per-night">per tent</div>
        </div>
        <div
          #extraTentPrice="curbnturfDisplayValidationErrorsContainerRef"
          curbnturfDisplayValidationErrorsContainer
        ></div>
      </div>
      <div *ngIf="amenity.key === 'vehicles' && selected('vehicles')" class="description-outer _6px">
        <div class="icon-w-label">
          <div class="per-night">How many?</div>
          <input
            type="number"
            class="text-field-rounded w-input"
            data-test="amenity-parking-count"
            min="0"
            [formControl]="extraParking.controls.count"
            [containerElement]="extraParkingCount"
          />
        </div>
        <div
          #extraParkingCount="curbnturfDisplayValidationErrorsContainerRef"
          curbnturfDisplayValidationErrorsContainer
        ></div>
        <div class="icon-w-label element-container">
          <div class="element-inner currency-rounded-left">
            <div class="element-bold">$</div>
          </div>
          <input
            type="number"
            class="text-field-rounded-right w-input"
            data-test="amenity-parking-price"
            [formControl]="extraParking.controls.price"
            [containerElement]="extraParkingPrice"
          />
          <div class="per-night">per vehicle</div>
        </div>
        <div
          #extraParkingPrice="curbnturfDisplayValidationErrorsContainerRef"
          curbnturfDisplayValidationErrorsContainer
        ></div>
      </div>
      <div *ngIf="amenity.key === 'water' && options(amenity.key)">
        <ion-item lines="none">
          <ion-label>Is there a direct hookup?</ion-label>
        </ion-item>
        <ion-radio-group [formControl]="options(amenity.key)">
          <ion-item lines="none">
            <ion-radio slot="start" mode="md" id="water-options-direct" value="direct" name="water"></ion-radio>
            <ion-label> Yes </ion-label>
          </ion-item>
          <ion-item lines="none">
            <ion-radio slot="start" mode="md" id="water-options-station" value="station" name="water"></ion-radio>
            <ion-label> No </ion-label>
          </ion-item>
        </ion-radio-group>
        <p *ngIf="potableWaterError" class="alert-danger">
          <i class="icon-cnt-times-circle"></i>
          {{ potableWaterError }}
        </p>
      </div>
      <div *ngIf="amenity.key === 'wifi' && options(amenity.key)" class="wifi-options">
        <div class="input-w-label curbnturf-percent-container" style="padding-top: 6px">
          <input
            type="text"
            (change)="wifiUpdate()"
            [formControl]="wifiDownload"
            placeholder="Download"
            class="text-field-rounded-left w-input"
          />
          <div class="element-inner speed-units currency-rounded-right">
            <div class="element-bold">Mbps</div>
          </div>
        </div>
        <div class="input-w-label curbnturf-percent-container">
          <input
            type="text"
            (change)="wifiUpdate()"
            [formControl]="wifiUpload"
            placeholder="Upload"
            class="text-field-rounded-left w-input"
          />
          <div class="element-inner speed-units currency-rounded-right">
            <div class="element-bold">Mbps</div>
          </div>
        </div>
        <p *ngIf="wifiError" class="alert-danger">
          <i class="icon-cnt-times-circle"></i>
          {{ wifiError }}
        </p>
      </div>

      <a
        class="small"
        [ngClass]="{ 'description-link': !showCustom }"
        (click)="expand(i)"
        *ngIf="!expanded[i] && selected(amenity.key)"
      >
        Add optional description...
      </a>
      <div *ngIf="expanded[i] && description(amenity.key)">
        <textarea  class="semi-rounded" [formControl]="description(amenity.key)"></textarea>
      </div>
    </div>
  </ng-container>

  <ng-container *ngIf="showCustom">
    <div class="cnt-extended-button" *ngFor="let customType of customTypes; let i = index">
      <label class="cnt-button" [ngClass]="{ active: selectedCustom(customType) }">
        <input type="checkbox" [value]="customType" (change)="toggleCustom(customType)" />
        <div class="cnt-button-copy">{{ customType }}</div>
      </label>

      <a
        class="small"
        (click)="expand(i + amenityEnum.length)"
        *ngIf="!expanded[i + amenityEnum.length] && selectedCustom(customType)"
      >
        Add optional description...
      </a>
      <div *ngIf="expanded[i + amenityEnum.length] && descriptionCustom(customType)">
        <textarea class="semi-rounded" [formControl]="descriptionCustom(customType)"></textarea>
      </div>
    </div>

    <label class="cnt-button">
      <input type="text" class="cnt-button-copy custom-name" placeholder="Add Amenity" (change)="addCustom($event)" />
    </label>
  </ng-container>
</div>
